module.exports = __webpack_public_path__ + "1f75d678b5526b783b2918b76f3262e7.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/twitter.png
 ** module id = 428
 ** module chunks = 0
 **/